import $ from 'jquery';

const gallery = () => {
	// two image galleries are in this section, one in news modules and another in home/about modules. the modal is being repurposed for both modules
	const gridSlider = $('.gridMod__cont');

	const gridSliderSettings = {
		infinite: false,
		slidesToShow: 1,
		slidesToScroll: 1,
		pauseOnHover: true,
		touchMove: true,
		arrows: false,
		cssEase: 'ease',
		accessibility: true,
		fade: true,
		arrows: true,
		prevArrow: $('.gridMod__prev'),
		nextArrow: $('.gridMod__next'),
		infinite: true,
		cssEase: 'ease-in-out',
	};

	if (gridSlider) {
		gridSlider.slick(gridSliderSettings);
	}

	let closeSlider = $('.gridMod__close');
	let gridMod = $('.gridMod');
	if (closeSlider && gridMod) {
		closeSlider.on('click', function () {
			gridMod.css('display', 'none');
		});
	}

	const modulesGrid = $('.grid__grid');
	if (modulesGrid.length > 0) {
		let gridDownloadButton = $('.gridMod__topRight');
		gridDownloadButton.on('click', function () {
			let id = $('.slick-active').find('.gridMod__block').data('id');
			$('.gridMod__dlBtn[data-id=' + id + ']').click();
		});

		gridSlider.on('afterChange', function () {
			let href = $('.slick-active').find('.gridMod__img').attr('src');
			gridDownloadButton[0].setAttribute('href', href);
		});
	}

	let gridItem = $('.grid__img');
	if (gridItem) {
		gridItem.on('click', function () {
			let slideno = $(this).data('id');
			gridMod.css('display', 'block');
			gridSlider.slick('slickGoTo', slideno);
			gridSlider.slick('setPosition');
		});
	}

	// about grid
	let aboutGridItem = $('.aboutGallery__imgCont');
	if (aboutGridItem) {
		aboutGridItem.on('click', function () {
			let slideno = $(this).data('id');
			gridMod.css('display', 'block');
			gridSlider.slick('slickGoTo', slideno);
			gridSlider.slick('setPosition');
		});
	}
};

export default gallery;
